<template>
  <v-card
    class="ratingCard pa-0 pa-sm-5"
    width="100%"
    max-width="680"
    justify="left"
    align="left"
    v-if="!resourceDetails.is_user_rated"
  >
    <v-card-text>
      <div class="file-name">
        On a Scale of 1 to 5, how do you rate these resources?
      </div>
      <v-rating
        v-model="rating"
        color="#FFA425"
        empty-icon="$ratingFull"
        background-color="#C2D1D9"
        dense
      />
      <v-form ref="reviewForm" lazy-validation>
        <div class="file-name mt-5 mb-2">
          Write a review
        </div>
        <v-textarea
          name="review"
          v-model="review"
          :rules="[]"
          placeholder="Write your message..."
          class="textarea"
          outlined
          hide-details
        />
      </v-form>
      <div class="text-center mt-8">
        <v-btn
          depressed
          color="#506CFF"
          dark
          class=" btn-text btn-width"
          ref="submitFeedbackBtn"
          @click="submitReviewForm"
          :loading="reviewFormLoading"
        >
          <span> Submit Your Review </span>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>

  <v-card
    color="#E1FAF1"
    class="pa-0 pa-sm-5"
    width="100%"
    max-width="680"
    style="border: 1px solid #E5E5E5;"
    flat
    v-else
  >
    <div class="file-name" style="color: #32C48D; text-align: center;">
      Thanks for your review. Your response have been received.
    </div>
  </v-card>
</template>

<script>
  import RULES from "../../../common/fieldRules";
  import Axios from "../../../api/BaseAxios";
  import AmplitudeHelper from "../../../amplitude";
  import Keys from "../../../constants/keys";
  import { API_CLIENT_URL } from "../../../constants/urls";

  export default {
    name: "RateNowSection",
    props: ["resourceDetails", "properties"],
    components: {},
    data() {
      return {
        rules: RULES,
        rating: 0,
        review: "",
        reviewFormLoading: false,
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {
      submitReviewForm() {
        var self = this;

        if (this.$refs.reviewForm.validate() && this.rating > 0) {
          this.reviewFormLoading = true;
          const successHandler = (res) => {
            AmplitudeHelper.registerEvent("Resource - Add Review - Success");
            self.reviewFormLoading = false;
            self.resourceDetails.is_user_rated = true;
            self.$refs.reviewForm.reset();
            console.log(res.data.data);
          };

          const failureHandler = (res) => {
            console.log(res);
            self.reviewFormLoading = false;
          };

          let requestParams = {};

          requestParams[Keys.ID] = this.resourceDetails.id;
          requestParams[Keys.RATING] = this.rating;
          requestParams[Keys.REVIEW] = this.review;

          Axios.request_POST(
            API_CLIENT_URL.reviewAdd,
            requestParams,
            {},
            successHandler,
            failureHandler,
            false
          );
        } else {
          this.$store.dispatch("snackBar/showToast", {
            message: "Please add a rating to this resource",
            color: "E",
          });
        }
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .file-name {
    font-weight: 900;
    font-size: 18px;
    line-height: 27px;
    color: #333333;
  }
  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
  }

  .btn-width {
    width: 260px;
  }

  .textarea {
    background: #f5f5f5;
    border-radius: 5px;
  }
</style>
